document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const price = document.querySelector('[data-product-price]');
    if (!variantSelect) return;
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});


// FC V6 mobile drawer
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-fc-mobile-menu]');
  const opener = document.querySelector('[data-fc-menu-open]');
  const closers = document.querySelectorAll('[data-fc-menu-close]');

  if (drawer && opener) {
    let closeTimer = null;

    const openMenu = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        opener.classList.add('is-menu-open');
      });
      opener.setAttribute('aria-expanded', 'true');
      opener.setAttribute('aria-label', 'Fermer le menu');
      document.body.classList.add('fc-menu-lock');
    };

    const closeMenu = () => {
      drawer.classList.remove('is-open');
      opener.classList.remove('is-menu-open');
      opener.setAttribute('aria-expanded', 'false');
      opener.setAttribute('aria-label', 'Ouvrir le menu');
      document.body.classList.remove('fc-menu-lock');

      closeTimer = setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        closeTimer = null;
      }, 260);
    };

    const toggleMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen =
        !drawer.hidden &&
        drawer.classList.contains('is-open');

      if (isOpen) closeMenu();
      else openMenu();
    };

    opener.addEventListener('click', toggleMenu);
    closers.forEach((el) => el.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) closeMenu();
    });
  }
});


// FC V11 — flocage conditionnel + quantité
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const flocageSelect = form.querySelector('[data-fc-flocage-select]');
    const flocageFields = form.querySelector('[data-fc-flocage-fields]');
    const flocageInputs = form.querySelectorAll('[data-fc-flocage-input]');

    if (flocageSelect && flocageFields) {
      const syncFlocage = () => {
        const shouldShow =
          flocageSelect.value === 'Personnalisé';

        flocageFields.hidden = !shouldShow;
        flocageFields.classList.toggle('is-visible', shouldShow);

        flocageInputs.forEach((input) => {
          input.disabled = !shouldShow;
          if (!shouldShow) input.value = '';
        });
      };

      flocageSelect.addEventListener('change', syncFlocage);
      syncFlocage();
    }

    const qty = form.querySelector('[data-fc-quantity]');
    if (qty) {
      const input = qty.querySelector('[data-fc-qty-input]');
      const minus = qty.querySelector('[data-fc-qty-minus]');
      const plus = qty.querySelector('[data-fc-qty-plus]');

      const normalize = () => {
        const value = Math.max(1, parseInt(input.value || '1', 10));
        input.value = value;
      };

      minus?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });

      plus?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      });

      input?.addEventListener('change', normalize);
    }
  });
});


// FC V12 — progression 3+1 en direct selon la quantité sélectionnée
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const offer = form.closest('.fc-product__info')?.querySelector('[data-fc-offer-box]');
    const qtyInput = form.querySelector('[data-fc-qty-input]');
    if (!offer || !qtyInput) return;

    const baseCartCount = parseInt(offer.dataset.cartCount || '0', 10);

    const bar = offer.querySelector('.fc-product-offer__bar');
    const message = offer.querySelector('.fc-product-offer__message');
    const countBadge = offer.querySelector('.fc-product-offer__count');
    const step1 = offer.querySelector('.fc-product-offer__step--1');
    const step2 = offer.querySelector('.fc-product-offer__step--2');
    const step3 = offer.querySelector('.fc-product-offer__step--3');
    const gift = offer.querySelector('.fc-product-offer__gift');

    const render = () => {
      const selectedQty = Math.max(1, parseInt(qtyInput.value || '1', 10));
      const projectedTotal = baseCartCount + selectedQty;
      const cycle = projectedTotal % 4;

      let progress = 0;
      let text = '';
      let unlocked = false;

      if (projectedTotal === 0) {
        progress = 0;
        text = 'Ajoutez votre premier maillot pour commencer.';
      } else if (cycle === 1) {
        progress = 0;
        text = 'Plus que 2 maillots avant de débloquer votre cadeau.';
      } else if (cycle === 2) {
        progress = 33;
        text = 'Plus qu’un maillot avant de débloquer votre cadeau.';
      } else if (cycle === 3) {
        progress = 66;
        text = 'Cadeau débloqué 🎁 Ajoutez maintenant votre 4e maillot.';
        unlocked = true;
      } else {
        progress = 100;
        text = 'Votre 4e maillot est débloqué 🎉';
        unlocked = true;
      }

      if (bar) bar.style.width = progress + '%';
      if (message) message.textContent = text;
      if (countBadge) countBadge.textContent = projectedTotal + ' article' + (projectedTotal > 1 ? 's' : '');

      step1?.classList.toggle('is-active', projectedTotal >= 1);
      step2?.classList.toggle('is-active', projectedTotal >= 2);
      step3?.classList.toggle('is-active', projectedTotal >= 3);
      gift?.classList.toggle('is-active', projectedTotal > 0 && projectedTotal % 4 === 0);

      offer.classList.toggle('is-unlocked', unlocked);
      offer.classList.remove('fc-offer-pulse');
      void offer.offsetWidth;
      offer.classList.add('fc-offer-pulse');
    };

    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);

    form.querySelector('[data-fc-qty-minus]')?.addEventListener('click', () => setTimeout(render, 0));
    form.querySelector('[data-fc-qty-plus]')?.addEventListener('click', () => setTimeout(render, 0));

    render();
  });
});


// FC V96 — panier AJAX : + / − sans rechargement de page
// Met à jour le prix, le total, l'offre 3+1 et la pastille panier en arrière-plan.
document.addEventListener('DOMContentLoaded', () => {
  let fcCartBusy = false;

  const refreshMiniDelivery = (root = document) => {
    const isBusinessDay = (date) => ![0, 6].includes(date.getDay());
    const addBusinessDays = (date, amount) => {
      const result = new Date(date);
      let added = 0;
      while (added < amount) {
        result.setDate(result.getDate() + 1);
        if (isBusinessDay(result)) added++;
      }
      return result;
    };
    const format = (date) => new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit' }).format(date);
    const now = new Date();
    const start = addBusinessDays(now, 8);
    const finish = addBusinessDays(now, 14);
    root.querySelectorAll('[data-fc-mini-delivery-range]').forEach((el) => {
      el.textContent = `${format(start)} - ${format(finish)}`;
    });
  };

  const setBusy = (busy) => {
    fcCartBusy = busy;
    const page = document.querySelector('.fc-cart-page');
    if (!page) return;
    page.classList.toggle('is-ajax-updating', busy);
    page.querySelectorAll('[data-fc-cart-minus], [data-fc-cart-plus], [data-fc-cart-input]').forEach((el) => {
      el.disabled = busy;
    });
  };

  const updateCart = async (input, quantity) => {
    if (fcCartBusy) return;
    const inputs = [...document.querySelectorAll('[data-fc-cart-input]')];
    const line = inputs.indexOf(input) + 1;
    if (line < 1) return;

    quantity = Math.max(0, parseInt(quantity || '0', 10));
    input.value = quantity;
    setBusy(true);

    try {
      const changeResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!changeResponse.ok) throw new Error('Impossible de mettre à jour le panier');

      const cart = await changeResponse.json();
      const htmlResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart`, {
        headers: { 'Accept': 'text/html' }
      });
      if (!htmlResponse.ok) throw new Error('Impossible de rafraîchir le panier');

      const html = await htmlResponse.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshPage = doc.querySelector('.fc-cart-page');
      const currentPage = document.querySelector('.fc-cart-page');
      if (freshPage && currentPage) {
        currentPage.replaceWith(freshPage);
        refreshMiniDelivery(freshPage);
      }

      // Synchronise la pastille du panier dans le header sans recharger la page.
      const headerCart = document.querySelector('.fc-header__cart, [href="/cart"]');
      let badge = document.querySelector('.fc-cart-count');
      if (cart.item_count > 0) {
        if (!badge && headerCart) {
          badge = document.createElement('span');
          badge.className = 'fc-cart-count';
          headerCart.appendChild(badge);
        }
        if (badge) badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    } catch (error) {
      console.error('[FC Maillot] Panier AJAX :', error);
      // En cas d'erreur réseau, on restaure la valeur réellement connue par Shopify.
      window.location.reload();
    } finally {
      setBusy(false);
    }
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-fc-cart-minus]');
    const plus = event.target.closest('[data-fc-cart-plus]');
    if (!minus && !plus) return;

    const control = event.target.closest('[data-fc-cart-quantity]');
    const input = control?.querySelector('[data-fc-cart-input]');
    if (!input || fcCartBusy) return;

    event.preventDefault();
    const current = Math.max(0, parseInt(input.value || '0', 10));
    const next = minus ? Math.max(0, current - 1) : current + 1;
    control.classList.add('is-changing');
    updateCart(input, next);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-fc-cart-input]');
    if (!input || fcCartBusy) return;
    updateCart(input, input.value);
  });

  refreshMiniDelivery();
});


// FC V18 — estimation de livraison dynamique
document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('[data-fc-delivery-estimate]');
  if (!widgets.length) return;

  const locale = 'fr-FR';

  const isBusinessDay = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const addBusinessDays = (date, amount) => {
    const result = new Date(date);
    let added = 0;
    while (added < amount) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) added++;
    }
    return result;
  };

  const formatShort = (date) =>
    new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' }).format(date);

  const formatLong = (date) =>
    new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' }).format(date);

  const now = new Date();

  // Préparation : 2–3 jours ouvrés ; livraison France : 10–14 jours ouvrés.
  const shipStart = addBusinessDays(now, 2);
  const shipEnd = addBusinessDays(now, 3);
  const deliveryStart = addBusinessDays(now, 8);
  const deliveryEnd = addBusinessDays(now, 14);

  document.querySelectorAll('[data-fc-mini-delivery-range]').forEach((el) => {
    el.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} - ${formatShort(deliveryEnd)}`));
  });

  widgets.forEach((widget) => {
    widget.querySelector('[data-fc-order-date]')?.replaceChildren(document.createTextNode(formatShort(now)));
    widget.querySelector('[data-fc-ship-range]')?.replaceChildren(document.createTextNode(`${formatShort(shipStart)} – ${formatShort(shipEnd)}`));
    widget.querySelector('[data-fc-delivery-range]')?.replaceChildren(document.createTextNode(`${formatLong(deliveryStart)} et ${formatLong(deliveryEnd)}`));
    widget.querySelector('[data-fc-delivery-range-bottom]')?.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} – ${formatShort(deliveryEnd)}`));
    widget.querySelector('[data-fc-tooltip-delivery-range]')?.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} – ${formatShort(deliveryEnd)}`));
  });

  // Compte à rebours quotidien jusqu'à 23:59:59, uniquement informatif.
  const updateCountdown = () => {
    const current = new Date();
    const end = new Date(current);
    end.setHours(23, 59, 59, 999);

    let diff = Math.max(0, end - current);
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);

    const text =
      `${String(hours).padStart(2, '0')}h ` +
      `${String(minutes).padStart(2, '0')}m ` +
      `${String(seconds).padStart(2, '0')}s`;

    widgets.forEach((widget) => {
      const el = widget.querySelector('[data-fc-order-countdown]');
      if (el) el.textContent = text;
    });
  };

  updateCountdown();
  setInterval(updateCountdown, 1000);
});


// FC V23 — carrousel produits responsive
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-carousel-section]').forEach((section) => {
    const carousel = section.querySelector('[data-fc-product-carousel]');
    const slides = [...section.querySelectorAll('[data-fc-carousel-slide]')];
    const prev = section.querySelector('[data-fc-carousel-prev]');
    const next = section.querySelector('[data-fc-carousel-next]');
    const dotsWrap = section.querySelector('[data-fc-carousel-dots]');
    const shell = section.querySelector('.fc-carousel-shell');

    if (!carousel || slides.length === 0) return;

    const stepSize = () => {
      const first = slides[0];
      if (!first) return carousel.clientWidth;
      const style = getComputedStyle(carousel);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const maxScroll = () => Math.max(0, carousel.scrollWidth - carousel.clientWidth);

    const pageCount = () => {
      const step = stepSize();
      if (!step) return 1;
      return Math.max(1, Math.round(maxScroll() / step) + 1);
    };

    let dots = [];

    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const count = pageCount();

      // Keep the UI compact even with many products.
      const maxDots = Math.min(count, slides.length);
      for (let i = 0; i < maxDots; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fc-carousel-dot';
        dot.setAttribute('aria-label', `Aller au produit ${i + 1}`);
        dot.addEventListener('click', () => {
          carousel.scrollTo({ left: Math.min(i * stepSize(), maxScroll()), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      dots = [...dotsWrap.children];
    };

    const update = () => {
      const step = stepSize() || 1;
      const index = Math.round(carousel.scrollLeft / step);
      const max = maxScroll();

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === Math.min(index, dots.length - 1)));
      slides.forEach((slide, i) => slide.classList.toggle('is-current', i === index));

      if (shell) {
        shell.classList.toggle('can-scroll-left', carousel.scrollLeft > 4);
        shell.classList.toggle('can-scroll-right', carousel.scrollLeft < max - 4);
      }
    };

    const goNext = () => {
      const max = maxScroll();
      if (carousel.scrollLeft >= max - 5) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: stepSize(), behavior: 'smooth' });
      }
    };

    const goPrev = () => {
      const max = maxScroll();
      if (carousel.scrollLeft <= 5) {
        carousel.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      }
    };

    prev?.addEventListener('click', goPrev);
    next?.addEventListener('click', goNext);

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goNext();
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goPrev();
      }
    });

    let ticking = false;
    carousel.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive:true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buildDots();
        update();
      }, 140);
    });

    buildDots();
    update();
  });
});


// FC V25 — galerie produit multi-images + plein écran
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-fc-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-fc-gallery-thumb]')];
    const prev = gallery.querySelector('[data-fc-gallery-prev]');
    const next = gallery.querySelector('[data-fc-gallery-next]');
    const counter = gallery.querySelector('[data-fc-gallery-current]');

    let current = 0;

    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
        slide.classList.toggle('is-active', i === current);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
      });
      if (counter) counter.textContent = String(current + 1);
      thumbs[current]?.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' });
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));

    // Swipe on the main image.
    let startX = null;
    const main = gallery.querySelector('[data-fc-gallery-main]');
    main?.addEventListener('touchstart', (e) => {
      startX = e.touches[0]?.clientX ?? null;
    }, { passive:true });
    main?.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const endX = e.changedTouches[0]?.clientX ?? startX;
      const delta = endX - startX;
      startX = null;
      if (Math.abs(delta) < 45) return;
      if (delta < 0) show(current + 1);
      else show(current - 1);
    }, { passive:true });

    // Fullscreen lightbox: images only.
    const lightbox = gallery.querySelector('[data-fc-product-lightbox]');
    const lightboxImages = lightbox ? [...lightbox.querySelectorAll('[data-fc-lightbox-image]')] : [];

    // V34: sortir le viewer de la galerie pour garantir un vrai plein écran
    // même si un parent utilise transform / contain / overflow sur iOS Safari.
    if (lightbox && lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    const closeButtons = lightbox ? lightbox.querySelectorAll('[data-fc-lightbox-close]') : [];
    const lightPrev = lightbox?.querySelector('[data-fc-lightbox-prev]');
    const lightNext = lightbox?.querySelector('[data-fc-lightbox-next]');
    const lightCounter = lightbox?.querySelector('[data-fc-lightbox-current]');

    let lightIndex = 0;

    const showLight = (index) => {
      if (!lightboxImages.length) return;
      lightIndex = (index + lightboxImages.length) % lightboxImages.length;
      lightboxImages.forEach((img, i) => img.hidden = i !== lightIndex);
      if (lightCounter) lightCounter.textContent = String(lightIndex + 1);
    };

    const openLightbox = (mediaIndex) => {
      if (!lightbox || !lightboxImages.length) return;
      const matching = lightboxImages.findIndex((img) =>
        Number(img.dataset.mediaIndex) === Number(mediaIndex)
      );
      showLight(matching >= 0 ? matching : 0);
      lightbox.hidden = false;
      document.documentElement.classList.add('fc-lightbox-open');
      document.body.classList.add('fc-lightbox-open');
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('fc-lightbox-open');
      document.body.classList.remove('fc-lightbox-open');
    };

    gallery.querySelectorAll('[data-fc-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => openLightbox(button.dataset.mediaIndex));
    });
    closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
    lightPrev?.addEventListener('click', () => showLight(lightIndex - 1));
    lightNext?.addEventListener('click', () => showLight(lightIndex + 1));

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showLight(lightIndex - 1);
      if (event.key === 'ArrowRight') showLight(lightIndex + 1);
    });

    show(0);
  });
});


// FC V41 — infos livraison au toucher
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-delivery-estimate]').forEach((widget) => {
    const steps = [...widget.querySelectorAll('[data-fc-delivery-step]')];
    if (!steps.length) return;

    const closeAll = (except = null) => {
      steps.forEach((step) => {
        if (step === except) return;
        step.classList.remove('is-tooltip-open');
        step.setAttribute('aria-expanded', 'false');
      });

      const hasOpen = steps.some((step) => step.classList.contains('is-tooltip-open'));
      widget.classList.toggle('has-tooltip-open', hasOpen);
    };

    steps.forEach((step) => {
      step.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = !step.classList.contains('is-tooltip-open');
        closeAll(step);
        step.classList.toggle('is-tooltip-open', open);
        step.setAttribute('aria-expanded', open ? 'true' : 'false');
        widget.classList.toggle('has-tooltip-open', open);
      });
    });

    document.addEventListener('click', (event) => {
      if (!widget.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  });
});


// FC V62 — recherche instantanée + validation vers tous les résultats
 document.addEventListener('DOMContentLoaded', () => {
  const modal=document.querySelector('[data-fc-live-search]');
  const openBtns=[...document.querySelectorAll('[data-fc-live-search-open]')];
  if(!modal||!openBtns.length)return;
  const input=modal.querySelector('[data-fc-live-search-input]');
  const results=modal.querySelector('[data-fc-live-search-results]');
  const form=modal.querySelector('[data-fc-live-search-form]');
  const clearBtn=modal.querySelector('[data-fc-live-search-clear]');
  let timer,controller;
  const esc=s=>String(s||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const close=()=>{modal.hidden=true;document.documentElement.classList.remove('fc-live-search-open');document.body.classList.remove('fc-live-search-open');openBtns.forEach(btn=>btn.setAttribute('aria-expanded','false'))};
  const open=(event)=>{event?.preventDefault();const drawer=document.querySelector('[data-fc-mobile-menu]');const menuBtn=document.querySelector('[data-fc-menu-open]');if(drawer&&!drawer.hidden){drawer.classList.remove('is-open');drawer.hidden=true;document.body.classList.remove('fc-menu-lock');menuBtn?.classList.remove('is-menu-open');menuBtn?.setAttribute('aria-expanded','false');menuBtn?.setAttribute('aria-label','Ouvrir le menu')}modal.hidden=false;document.documentElement.classList.add('fc-live-search-open');document.body.classList.add('fc-live-search-open');openBtns.forEach(btn=>btn.setAttribute('aria-expanded','true'));setTimeout(()=>input.focus(),30)};
  openBtns.forEach(btn=>btn.addEventListener('click',open));
  modal.querySelectorAll('[data-fc-live-search-close]').forEach(x=>x.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});

  const render=(items,q)=>{
    if(!items.length){results.innerHTML='<div class="fc-live-search__empty">Aucun résultat pour « '+esc(q)+' »</div>';return}
    const labels={collection:'Collections',product:'Produits',page:'Pages'};let html='';
    ['collection','product','page'].forEach(type=>{
      const group=items.filter(x=>x.resource_type===type);if(!group.length)return;
      html+='<div class="fc-live-search__group-title">'+labels[type]+'</div>';
      group.forEach(x=>{
        const imageUrl=(typeof x.image==='string'?x.image:(x.image&&x.image.url))||(typeof x.featured_image==='string'?x.featured_image:(x.featured_image&&x.featured_image.url))||(x.featured_media&&x.featured_media.preview_image&&x.featured_media.preview_image.url)||'';
        const img=imageUrl?'<img src="'+esc(imageUrl)+'" alt="'+esc(x.title)+'" loading="lazy">':'<span class="fc-live-search__thumb" data-fc-thumb-url="'+esc(x.url)+'" data-fc-thumb-type="'+esc(type)+'"></span>';
        html+='<a class="fc-live-search__item" href="'+esc(x.url)+'">'+img+'<span><strong>'+esc(x.title)+'</strong>'+(x.price?'<small>'+esc(x.price)+'</small>':'')+'</span></a>'
      });
    });
    results.innerHTML=html;
    results.querySelectorAll('[data-fc-thumb-url]').forEach(async ph=>{try{
      const r=await fetch(ph.dataset.fcThumbUrl,{headers:{'X-Requested-With':'XMLHttpRequest'}});if(!r.ok)return;
      const t=await r.text();const doc=new DOMParser().parseFromString(t,'text/html');let src='';
      const og=doc.querySelector('meta[property="og:image"]');if(og)src=og.content||'';
      const candidates=[...doc.querySelectorAll('.rte img,.fc-page-content img,.collection-hero img,main img,article img')];
      const found=candidates.find(el=>el.getAttribute('src')||el.getAttribute('data-src')||el.getAttribute('data-srcset')||el.getAttribute('srcset'));
      if(found){src=found.currentSrc||found.getAttribute('src')||found.getAttribute('data-src')||src;if(!src){const ss=found.getAttribute('data-srcset')||found.getAttribute('srcset')||'';src=ss.split(',')[0].trim().split(' ')[0]||''}}
      if(src&&src.startsWith('//'))src=location.protocol+src;
      if(src){const im=document.createElement('img');im.src=src;im.alt='';im.loading='lazy';ph.replaceWith(im)}
    }catch(e){}});
  };

  const runSearch=async()=>{
    clearTimeout(timer);const q=input.value.trim();
    if(q.length<2){results.innerHTML='<div class="fc-live-search__hint">Écrivez au moins 2 caractères.</div>';input.focus();return}
    controller?.abort();controller=new AbortController();results.innerHTML='<div class="fc-live-search__hint">Recherche…</div>';
    try{
      const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last',{signal:controller.signal});
      const d=await r.json();const res=d.resources&&d.resources.results?d.resources.results:{};const items=[];
      ['collections','products','pages'].forEach(k=>(res[k]||[]).forEach(x=>items.push({...x,resource_type:k.slice(0,-1)})));
      render(items,q)
    }catch(e){if(e.name!=='AbortError')results.innerHTML='<div class="fc-live-search__empty">Impossible de charger la recherche.</div>'}
  };
  input.addEventListener('input',()=>{clearTimeout(timer);const q=input.value.trim();if(q.length<2){results.innerHTML=q?'<div class="fc-live-search__hint">Écrivez au moins 2 caractères.</div>':'<div class="fc-live-search__hint">Commencez à écrire pour afficher les résultats.</div>';return}timer=setTimeout(runSearch,220)});
  form.addEventListener('submit',e=>{
    e.preventDefault();
    const q=input.value.trim();
    if(!q){ input.focus(); return; }
    window.location.href='/search?type=product%2Cpage%2Ccollection&q='+encodeURIComponent(q);
  });
  clearBtn.addEventListener('click',()=>{
    clearTimeout(timer);controller?.abort();
    if(input.value.trim()){
      input.value='';
      results.innerHTML='<div class="fc-live-search__hint">Commencez à écrire pour afficher les résultats.</div>';
      input.focus();
    }else{
      close();
    }
  });
 });

// FC V68 — guide des tailles intelligent + animations + flocage en majuscules
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[name="properties[Flocage haut]"], input[name="properties[Flocage bas]"]').forEach(input => {
    input.style.textTransform = 'uppercase';
    input.addEventListener('input', () => { input.value = input.value.toLocaleUpperCase('fr-FR'); });
    input.addEventListener('blur', () => { input.value = input.value.toLocaleUpperCase('fr-FR'); });
  });

  document.querySelectorAll('[data-fc-size-guide]').forEach(guide => {
    const form = guide.closest('form'); const select = form?.querySelector('[data-variant-select]');
    const open = form?.querySelector('[data-fc-size-open]'); const closes = guide.querySelectorAll('[data-fc-size-close]');
    const result = guide.querySelector('[data-fc-size-result]'); const message = guide.querySelector('[data-fc-size-message]'); const choose = guide.querySelector('[data-fc-size-choose]');
    let recommendation = ''; let mode = guide.dataset.jacket === 'true' ? 'adult' : 'adult'; let fit = 'normal';
    const norm = s => (s||'').toUpperCase().replace(/\s+/g,'').replace('XXL','2XL');
    const variantFor = size => select ? [...select.options].find(o => norm(o.textContent).includes(norm(size))) : null;
    const show = () => { guide.hidden=false; document.body.classList.add('fc-size-lock'); requestAnimationFrame(()=>guide.classList.add('is-open')); setTimeout(update,0); };
    const hide = () => { guide.classList.remove('is-open'); document.body.classList.remove('fc-size-lock'); setTimeout(()=>{guide.hidden=true},260); };
    open?.addEventListener('click', show); closes.forEach(x=>x.addEventListener('click', hide));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!guide.hidden)hide()});
    guide.querySelectorAll('[data-fc-size-tab]').forEach(btn=>btn.addEventListener('click',()=>{mode=btn.dataset.fcSizeTab;guide.querySelectorAll('[data-fc-size-tab]').forEach(b=>b.classList.toggle('is-active',b===btn));guide.querySelectorAll('[data-fc-size-pane]').forEach(p=>p.hidden=p.dataset.fcSizePane!==mode);update()}));
    guide.querySelectorAll('[data-fc-fit]').forEach(btn=>btn.addEventListener('click',()=>{fit=btn.dataset.fcFit;guide.querySelectorAll('[data-fc-fit]').forEach(b=>b.classList.toggle('is-active',b===btn));update()}));
    const ranges=[['[data-fc-height]','[data-fc-height-out]'],['[data-fc-weight]','[data-fc-weight-out]'],['[data-fc-child-age]','[data-fc-child-age-out]'],['[data-fc-child-height]','[data-fc-child-height-out]'],['[data-fc-child-weight]','[data-fc-child-weight-out]']];
    ranges.forEach(([a,b])=>{const i=guide.querySelector(a),o=guide.querySelector(b);i?.addEventListener('input',()=>{if(o)o.textContent=i.value;update()})});
    function update(){
      let size='';
      if(guide.dataset.jacket==='true'){
        const h=+guide.querySelector('[data-fc-height]')?.value||175,w=+guide.querySelector('[data-fc-weight]')?.value||65;
        const scores=[['S',166.5,55],['M',172.5,62.5],['L',177.5,69],['XL',182.5,78.5],['2XL',182.5,86.5],['3XL',190,93.5],['4XL',197.5,101.5]];
        size=scores.sort((a,b)=>((h-a[1])/7)**2+((w-a[2])/10)**2-(((h-b[1])/7)**2+((w-b[2])/10)**2))[0][0];
      } else if(mode==='child'){
        const age=+guide.querySelector('[data-fc-child-age]')?.value||8;
        const h=+guide.querySelector('[data-fc-child-height]')?.value||135;
        const w=+guide.querySelector('[data-fc-child-weight]')?.value||30;
        const child=[['2-3 ans',2.5,100,15],['3-4 ans',3.5,110,18],['4-5 ans',4.5,120,21],['6-7 ans',6.5,130,25],['8-9 ans',8.5,140,31],['10-11 ans',10.5,150,39],['12-13 ans',12.5,160,48]];
        size=child.slice().sort((a,b)=>(((age-a[1])/1.8)**2+((h-a[2])/10)**2+((w-a[3])/9)**2)-(((age-b[1])/1.8)**2+((h-b[2])/10)**2+((w-b[3])/9)**2))[0][0];
      } else {
        const h=+guide.querySelector('[data-fc-height]')?.value||175;
        const w=+guide.querySelector('[data-fc-weight]')?.value||70;
        const adult=[['S',165,55],['M',170,63],['L',175,72],['XL',180,82],['2XL',185,92],['3XL',190,103],['4XL',195,115]];
        let idx=adult.slice().sort((a,b)=>(((h-a[1])/7)**2+((w-a[2])/11)**2)-(((h-b[1])/7)**2+((w-b[2])/11)**2))[0];
        let pos=adult.findIndex(x=>x[0]===idx[0]); if(fit==='tight')pos=Math.max(0,pos-1);if(fit==='loose')pos=Math.min(adult.length-1,pos+1);size=adult[pos][0];
      }
      recommendation=size; result.classList.remove('fc-reco-pop'); void result.offsetWidth; result.classList.add('fc-reco-pop'); result.textContent=size; const opt=variantFor(size);
      message.textContent=opt&&!opt.disabled?'On te conseille la taille '+size:'Taille '+size+' conseillée — vérifie sa disponibilité';
      choose.disabled=!opt||opt.disabled; choose.textContent=opt&&!opt.disabled?'Choisir la taille '+size:'Taille non disponible';
    }
    choose?.addEventListener('click',()=>{const opt=variantFor(recommendation);if(!opt||opt.disabled)return;select.value=opt.value;select.dispatchEvent(new Event('change',{bubbles:true}));hide();select.scrollIntoView({behavior:'smooth',block:'center'})});
    update();
  });
});

// FC V72 — pagination + indice de swipe pour Championnats et Pays
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-hub-section]').forEach(section => {
    const carousel = section.querySelector('[data-fc-hub-carousel]');
    const slides = [...section.querySelectorAll('[data-fc-hub-slide]')];
    const dotsWrap = section.querySelector('[data-fc-hub-dots]');
    if (!carousel || !slides.length || !dotsWrap) return;
    let dots=[];
    const step=()=>{const s=getComputedStyle(carousel);return slides[0].getBoundingClientRect().width+(parseFloat(s.columnGap||s.gap||0)||0)};
    const max=()=>Math.max(0,carousel.scrollWidth-carousel.clientWidth);
    const count=()=>Math.max(1,Math.round(max()/(step()||1))+1);
    const build=()=>{dotsWrap.innerHTML='';for(let i=0;i<count();i++){const d=document.createElement('button');d.type='button';d.className='fc-carousel-dot';d.setAttribute('aria-label',`Aller à la carte ${i+1}`);d.addEventListener('click',()=>carousel.scrollTo({left:Math.min(i*step(),max()),behavior:'smooth'}));dotsWrap.appendChild(d)}dots=[...dotsWrap.children];update()};
    const update=()=>{const i=Math.round(carousel.scrollLeft/(step()||1));dots.forEach((d,n)=>d.classList.toggle('is-active',n===Math.min(i,dots.length-1)))};
    let ticking=false;carousel.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(()=>{update();ticking=false});ticking=true}},{passive:true});
    let timer;window.addEventListener('resize',()=>{clearTimeout(timer);timer=setTimeout(build,140)});build();
  });
});

/* FC MAILLOT V85 — subtle desktop parallax for the existing hero artwork */
(() => {
  const hero = document.querySelector('.fc-hero__box');
  if (!hero || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  let raf = 0;
  hero.addEventListener('pointermove', (e) => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const r = hero.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width - .5) * -12;
      const y = ((e.clientY - r.top) / r.height - .5) * -8;
      hero.style.setProperty('--fc-hero-x', `${x.toFixed(2)}px`);
      hero.style.setProperty('--fc-hero-y', `${y.toFixed(2)}px`);
    });
  }, { passive:true });
  hero.addEventListener('pointerleave', () => {
    hero.style.setProperty('--fc-hero-x', '0px');
    hero.style.setProperty('--fc-hero-y', '0px');
  });
})();


// FC V105 — édition taille/flocage depuis le panier + partage du panier.
document.addEventListener('DOMContentLoaded', () => {
  const rootRoute = () => window.Shopify?.routes?.root || '/';
  let editorBusy = false;

  const formatMiniDelivery = (root = document) => {
    const isBusinessDay = (date) => ![0, 6].includes(date.getDay());
    const addBusinessDays = (date, amount) => {
      const result = new Date(date); let added = 0;
      while (added < amount) { result.setDate(result.getDate() + 1); if (isBusinessDay(result)) added++; }
      return result;
    };
    const format = (date) => new Intl.DateTimeFormat('fr-FR', { day:'2-digit', month:'2-digit' }).format(date);
    const start = addBusinessDays(new Date(), 8); const finish = addBusinessDays(new Date(), 14);
    root.querySelectorAll('[data-fc-mini-delivery-range]').forEach(el => { el.textContent = `${format(start)} - ${format(finish)}`; });
  };

  const syncHeaderCart = (cart) => {
    const headerCart = document.querySelector('.fc-header__cart, a[href$="/cart"], a[href="/cart"]');
    let badge = document.querySelector('.fc-cart-count');
    if (cart.item_count > 0) {
      if (!badge && headerCart) { badge = document.createElement('span'); badge.className = 'fc-cart-count'; headerCart.appendChild(badge); }
      if (badge) badge.textContent = cart.item_count;
    } else if (badge) badge.remove();
  };

  const refreshCartPage = async (cart) => {
    const response = await fetch(`${rootRoute()}cart`, { headers:{'Accept':'text/html'} });
    if (!response.ok) throw new Error('Impossible de rafraîchir le panier');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.fc-cart-page');
    const current = document.querySelector('.fc-cart-page');
    if (fresh && current) { current.replaceWith(fresh); formatMiniDelivery(fresh); }
    if (cart) syncHeaderCart(cart);
  };

  const setEditorBusy = (line, busy) => {
    editorBusy = busy;
    document.querySelector('.fc-cart-page')?.classList.toggle('is-ajax-updating', busy);
    line?.querySelectorAll('[data-fc-cart-editor] select, [data-fc-cart-editor] input, [data-fc-cart-save]').forEach(el => { el.disabled = busy; });
  };

  const collectProperties = (line) => {
    const properties = {};
    line.querySelectorAll('[data-fc-cart-extra-property]').forEach(input => {
      const name = input.dataset.propertyName; if (name && input.value !== '') properties[name] = input.value;
    });
    const flocage = line.querySelector('[data-fc-cart-flocage]')?.value || 'Aucun';
    properties['Flocage'] = flocage;
    if (flocage === 'Personnalisé') {
      const top = (line.querySelector('[data-fc-cart-flocage-haut]')?.value || '').trim().toLocaleUpperCase('fr-FR');
      const number = (line.querySelector('[data-fc-cart-numero]')?.value || '').trim();
      const bottom = (line.querySelector('[data-fc-cart-flocage-bas]')?.value || '').trim().toLocaleUpperCase('fr-FR');
      if (top) properties['Flocage haut'] = top;
      if (number) properties['Numéro'] = number;
      if (bottom) properties['Flocage bas'] = bottom;
    }
    return properties;
  };

  document.addEventListener('change', (event) => {
    const flocage = event.target.closest('[data-fc-cart-flocage]');
    if (!flocage) return;
    const editor = flocage.closest('[data-fc-cart-editor]');
    const fields = editor?.querySelector('[data-fc-cart-flocage-fields]');
    if (fields) fields.hidden = flocage.value !== 'Personnalisé';
  });

  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-fc-cart-flocage-haut], [data-fc-cart-flocage-bas]');
    if (field) field.value = field.value.toLocaleUpperCase('fr-FR');
  });

  document.addEventListener('click', async (event) => {
    const save = event.target.closest('[data-fc-cart-save]');
    if (!save || editorBusy) return;
    event.preventDefault();
    const line = save.closest('[data-fc-cart-line]');
    if (!line) return;
    const status = line.querySelector('[data-fc-cart-edit-status]');
    const quantity = Math.max(1, parseInt(line.querySelector('[data-fc-cart-input]')?.value || '1', 10));
    const currentVariant = String(line.dataset.variantId || '');
    const nextVariant = String(line.querySelector('[data-fc-cart-variant]')?.value || currentVariant);
    const key = line.dataset.lineKey;
    const properties = collectProperties(line);
    if (!key || !nextVariant) return;

    setEditorBusy(line, true);
    if (status) status.textContent = 'Enregistrement…';
    try {
      let cart;
      if (nextVariant !== currentVariant) {
        const addResponse = await fetch(`${rootRoute()}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(nextVariant), quantity, properties}]})
        });
        if (!addResponse.ok) throw new Error('Cette taille ne peut pas être ajoutée');
        const removeResponse = await fetch(`${rootRoute()}cart/change.js`, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key, quantity:0})
        });
        if (!removeResponse.ok) throw new Error('Impossible de remplacer la taille');
        cart = await removeResponse.json();
      } else {
        const response = await fetch(`${rootRoute()}cart/change.js`, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key, quantity, properties})
        });
        if (!response.ok) throw new Error('Impossible de modifier cet article');
        cart = await response.json();
      }
      if (status) status.textContent = 'Modifications enregistrées ✓';
      await refreshCartPage(cart);
    } catch (error) {
      console.error('[FC Maillot] Édition panier :', error);
      if (status) status.textContent = 'Une erreur est survenue. Réessayez.';
      setEditorBusy(line, false);
      return;
    }
    editorBusy = false;
  });


  formatMiniDelivery();
});

/* FC MAILLOT V105 — partage de panier premium : variantes, quantités et flocages conservés. */
(function(){
  if (window.__fcMaillotCartShareV105) return;
  window.__fcMaillotCartShareV105 = true;

  const routeRoot = () => window.Shopify?.routes?.root || '/';
  const cartUrl = () => `${routeRoot()}cart`;

  const encodePayload = (value) => {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  };

  const decodePayload = (value) => {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - normalized.length % 4) % 4);
    const binary = atob(padded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(bytes));
  };

  const normalizeItems = (items) => {
    if (!Array.isArray(items)) return [];
    return items.slice(0, 60).map((item) => {
      const id = Number.parseInt(item?.id, 10);
      const quantity = Math.min(99, Math.max(1, Number.parseInt(item?.quantity, 10) || 1));
      const properties = item?.properties && typeof item.properties === 'object' && !Array.isArray(item.properties) ? item.properties : undefined;
      const rawSellingPlan = item?.selling_plan || item?.selling_plan_allocation?.selling_plan?.id || null;
      const sellingPlan = rawSellingPlan ? Number.parseInt(rawSellingPlan, 10) : null;
      if (!Number.isFinite(id) || id <= 0) return null;
      const clean = { id, quantity };
      if (properties && Object.keys(properties).length) clean.properties = properties;
      if (Number.isFinite(sellingPlan) && sellingPlan > 0) clean.selling_plan = sellingPlan;
      return clean;
    }).filter(Boolean);
  };

  const getCurrentShareItems = async () => {
    const response = await fetch(`${routeRoot()}cart.js`, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('Impossible de lire le panier.');
    const cart = await response.json();
    return normalizeItems(cart?.items || []);
  };

  const makeShareUrl = (items) => {
    const url = new URL(cartUrl(), window.location.origin);
    url.searchParams.set('fcm_share', encodePayload(items));
    return url.toString();
  };

  const setShareStatus = (message, state = 'success') => {
    const wrap = document.querySelector('[data-fc-cart-share-wrap]');
    const status = wrap?.querySelector('[data-fc-cart-share-status]');
    if (!wrap || !status) return;
    wrap.classList.remove('is-success', 'is-error');
    status.textContent = message;
    wrap.classList.add(state === 'error' ? 'is-error' : 'is-success');
    window.clearTimeout(window.__fcMaillotShareStatusTimer);
    window.__fcMaillotShareStatusTimer = window.setTimeout(() => {
      wrap.classList.remove('is-success', 'is-error');
      status.textContent = '';
    }, 2800);
  };

  const copyText = async (text) => {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const ok = document.execCommand('copy');
    field.remove();
    return ok;
  };

  const showToast = (message) => {
    document.querySelector('.fc-cart-share-toast')?.remove();
    const toast = document.createElement('div');
    toast.className = 'fc-cart-share-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = `<b>✓</b><span>${message}</span>`;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 240);
    }, 3200);
  };

  const shareCurrentCart = async () => {
    let items = [];
    try {
      setShareStatus('Préparation du lien…');
      items = await getCurrentShareItems();
    } catch (error) {
      setShareStatus('Impossible de créer le lien pour ce panier.', 'error');
      return;
    }
    if (!items.length) {
      setShareStatus('Impossible de créer le lien pour ce panier.', 'error');
      return;
    }
    const shareUrl = makeShareUrl(items);
    const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
    const payload = {
      title: 'Ma sélection FC Maillot',
      text: `Regarde ma sélection FC Maillot — ${itemCount} article${itemCount > 1 ? 's' : ''} ⚽`,
      url: shareUrl
    };

    if (navigator.share) {
      try {
        await navigator.share(payload);
        setShareStatus('Panier prêt à être partagé ✓');
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    try {
      const copied = await copyText(shareUrl);
      setShareStatus(copied ? 'Lien du panier copié ✓' : 'Copie du lien impossible.', copied ? 'success' : 'error');
    } catch (error) {
      setShareStatus('Copie du lien impossible.', 'error');
    }
  };

  const requestJson = async (path, options = {}) => {
    const response = await fetch(`${routeRoot()}${path}`, {
      ...options,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', ...(options.headers || {}) }
    });
    let json = null;
    try { json = await response.json(); } catch (error) {}
    if (!response.ok) throw new Error(json?.description || json?.message || 'Une erreur est survenue.');
    return json;
  };

  const closeModal = (modal, cleanUrl = false) => {
    if (!modal) return;
    modal.classList.remove('is-visible');
    document.body.style.removeProperty('overflow');
    if (cleanUrl) history.replaceState({}, '', cartUrl());
    window.setTimeout(() => modal.remove(), 230);
  };

  const loadSharedCart = async (items, mode, modal) => {
    const actions = modal.querySelectorAll('[data-fcm-shared-action]');
    const errorBox = modal.querySelector('[data-fcm-shared-error]');
    actions.forEach((button) => { button.disabled = true; });
    errorBox?.classList.remove('is-visible');

    try {
      if (mode === 'replace') await requestJson('cart/clear.js', { method: 'POST', body: '{}' });
      await requestJson('cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });
      window.location.replace(`${cartUrl()}?fcm_shared=1`);
    } catch (error) {
      actions.forEach((button) => { button.disabled = false; });
      if (errorBox) {
        errorBox.textContent = error?.message || 'Impossible de charger ce panier pour le moment.';
        errorBox.classList.add('is-visible');
      }
    }
  };

  const openSharedCartModal = async (items) => {
    let currentCount = Number.parseInt(document.querySelector('.fc-cart-count')?.textContent || '0', 10) || 0;
    try {
      const current = await fetch(`${routeRoot()}cart.js`, { headers: { 'Accept': 'application/json' } }).then((response) => response.json());
      currentCount = current?.item_count || 0;
    } catch (error) {}

    const sharedCount = items.reduce((sum, item) => sum + item.quantity, 0);
    const modal = document.createElement('div');
    modal.className = 'fc-cart-share-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'FcSharedCartTitle');
    modal.innerHTML = `
      <div class="fc-cart-share-modal__card">
        <div class="fc-cart-share-modal__top">
          <span class="fc-cart-share-modal__badge" aria-hidden="true">↗</span>
          <div>
            <h2 class="fc-cart-share-modal__title" id="FcSharedCartTitle">On t’a partagé un panier 💜</h2>
            <p class="fc-cart-share-modal__text">Retrouve la sélection FC Maillot qui vient de t’être envoyée, avec les bonnes tailles, flocages et quantités.</p>
          </div>
          <button class="fc-cart-share-modal__close" type="button" data-fcm-shared-close aria-label="Fermer">×</button>
        </div>
        <div class="fc-cart-share-modal__info"><span>⚽</span><span><b>${sharedCount} article${sharedCount > 1 ? 's' : ''}</b> dans la sélection partagée</span></div>
        <div class="fc-cart-share-modal__actions">
          <button class="fc-cart-share-modal__action fc-cart-share-modal__action--primary" type="button" data-fcm-shared-action="replace">${currentCount > 0 ? 'Remplacer mon panier' : 'Charger ce panier'} →</button>
          ${currentCount > 0 ? '<button class="fc-cart-share-modal__action fc-cart-share-modal__action--secondary" type="button" data-fcm-shared-action="add">Ajouter à mon panier</button>' : ''}
        </div>
        <div class="fc-cart-share-modal__error" data-fcm-shared-error role="alert"></div>
      </div>`;

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => modal.classList.add('is-visible'));
    modal.querySelector('[data-fcm-shared-close]')?.focus();

    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('[data-fcm-shared-close]')) {
        closeModal(modal, true);
        return;
      }
      const action = event.target.closest('[data-fcm-shared-action]');
      if (action) loadSharedCart(items, action.dataset.fcmSharedAction, modal);
    });

    document.addEventListener('keydown', function escapeSharedCart(event) {
      if (event.key !== 'Escape' || !document.body.contains(modal)) return;
      closeModal(modal, true);
      document.removeEventListener('keydown', escapeSharedCart);
    });
  };

  const handleIncomingShare = () => {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get('fcm_share');
    if (encoded) {
      try {
        const items = normalizeItems(decodePayload(encoded));
        if (!items.length) throw new Error('Panier vide');
        openSharedCartModal(items);
      } catch (error) {
        history.replaceState({}, '', cartUrl());
        showToast('Ce lien de panier n’est plus valide.');
      }
      return;
    }
    if (params.get('fcm_shared') === '1') {
      showToast('Panier partagé chargé avec succès');
      history.replaceState({}, '', cartUrl());
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fc-cart-share]');
    if (!button) return;
    event.preventDefault();
    shareCurrentCart();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleIncomingShare, { once: true });
  else handleIncomingShare();
})();

